const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Listas de Contactos Segmentadas",
    summary:
      "Organiza y segmenta audiencias para campañas y comunicaciones masivas. Permite crear listas, importar contactos masivamente vía hojas de cálculo Excel, y consultar o depurar registros de cada lista.",
  },
  sections: [
    {
      id: "gestion_listas",
      title: "1. Creación y Mantenimiento de Listas",
      description:
        "Crea listas con nombres descriptivos para agrupar clientes según intereses o etapas comerciales.",
      items: [
        {
          id: "agregar_lista",
          title: "Adicionar Lista",
          definition:
            "Define un nombre único para la lista de contactos que servirá como destino de campañas.",
        },
        {
          id: "descargar_plantilla",
          title: "Plantilla Excel de Importación",
          definition:
            "Descarga la hoja de cálculo modelo (.xlsx) con los encabezados requeridos (nombre, número, email) para importar contactos sin errores.",
        },
        {
          id: "formato_telefonico_requerido",
          title: "Formato Telefónico Obligatorio (E.164)",
          definition:
            "Los números deben incluir código de país sin símbolos (ej: 51987654321) y tener entre 8 y 13 dígitos. No se admiten números locales sin código de país.",
        },
        {
          id: "filtro_antiban_lids",
          title: "Filtro Preventivo Anti-LID de Grupos",
          definition:
            "El importador analiza las columnas y la longitud numérica antes de procesar. Si el archivo proviene de una extracción de grupo (columna 'Es Administrador' o números de 15 dígitos LID), se cancela la carga de inmediato para evitar que Meta bloquee tu línea por envío no autorizado a miembros anónimos.",
        },
      ],
    },
    {
      id: "administracion_contactos",
      title: "2. Administración de Registros",
      description:
        "Inspección detallada y acciones sobre los contactos de la lista.",
      items: [
        {
          id: "ver_contactos",
          title: "Explorar Contactos de la Lista",
          definition:
            "Accede a la vista detallada de contactos dentro de la lista para añadir nuevos registros, editar información o cargar archivos masivos.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Segmented Contact Lists",
    summary:
      "Organize and segment audiences for broadcast campaigns. Create lists, import contacts in bulk via Excel spreadsheets, and manage individual records.",
  },
  sections: [
    {
      id: "gestion_listas",
      title: "1. List Management",
      description:
        "Create descriptive lists to group customers by interests or sales stages.",
      items: [
        {
          id: "agregar_lista",
          title: "Add List",
          definition:
            "Define a unique name for the contact list to use as a campaign destination.",
        },
        {
          id: "descargar_plantilla",
          title: "Excel Import Template",
          definition:
            "Download the sample spreadsheet (.xlsx) with the necessary headers (name, phone, email) to import contacts without errors.",
        },
        {
          id: "formato_telefonico_requerido",
          title: "Required Phone Format (E.164)",
          definition:
            "Numbers must include country code without symbols (e.g., 12025550198) and have between 8 and 13 digits. Local numbers without country codes are not accepted.",
        },
        {
          id: "filtro_antiban_lids",
          title: "Preventive Group Anti-LID Filter",
          definition:
            "The importer parses columns and digit lengths before processing. If the file comes from a group export ('Es Administrador' column or 15-digit LID numbers), upload is immediately rejected to prevent Meta from banning your line for unauthorized messaging to anonymous members.",
        },
      ],
    },
    {
      id: "administracion_contactos",
      title: "2. Record Administration",
      description:
        "Inspect and manage contacts within each list.",
      items: [
        {
          id: "ver_contactos",
          title: "Explore List Contacts",
          definition:
            "Navigate into the list to add new contacts, edit information, or upload bulk contact sheets.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial do BotMix",
    title: "Listas de Contatos Segmentadas",
    summary:
      "Organize e segmente públicos para campanhas e disparos em massa. Crie listas, importe contatos via planilhas Excel e gerencie os registros.",
  },
  sections: [
    {
      id: "gestion_listas",
      title: "1. Criação e Gestão de Listas",
      description:
        "Crie listas com nomes claros para agrupar clientes por interesse ou estágio comercial.",
      items: [
        {
          id: "agregar_lista",
          title: "Adicionar Lista",
          definition:
            "Crie um nome único para a lista de contatos que servirá de destino para campanhas.",
        },
        {
          id: "descargar_plantilla",
          title: "Planilha Modelo de Importação",
          definition:
            "Baixe o modelo em Excel (.xlsx) com as colunas corretas para importar contatos sem falhas.",
        },
        {
          id: "formato_telefonico_requerido",
          title: "Formato Telefônico Obrigatório (E.164)",
          definition:
            "Os números devem incluir código de país sem símbolos (ex: 5511999998888) e possuir entre 8 e 13 dígitos. Números locais sem DDI não são aceitos.",
        },
        {
          id: "filtro_antiban_lids",
          title: "Filtro Preventivo Anti-LID de Grupos",
          definition:
            "O importador analisa colunas e tamanho numérico antes do processamento. Se a planilha vier de extração de grupos (coluna 'Es Administrador' ou números LID de 15 dígitos), o envio é cancelado imediatamente para evitar banimentos por envio não autorizado.",
        },
      ],
    },
    {
      id: "administracion_contactos",
      title: "2. Administração de Contatos",
      description:
        "Acesse e gerencie os contatos de cada lista.",
      items: [
        {
          id: "ver_contactos",
          title: "Ver Contatos da Lista",
          definition:
            "Acesse a lista completa de contatos para adicionar registros, editar dados ou importar planilhas.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Listes de Contacts Segmentées",
    summary:
      "Organisez et segmentez vos audiences pour des campagnes de diffusion. Créez des listes, importez des contacts via Excel et gérez les enregistrements.",
  },
  sections: [
    {
      id: "gestion_listas",
      title: "1. Gestion des Listes",
      description:
        "Créez des listes ciblées pour regrouper vos clients par intérêt.",
      items: [
        {
          id: "agregar_lista",
          title: "Ajouter une Liste",
          definition:
            "Définissez un nom unique pour la liste de contacts cible.",
        },
        {
          id: "descargar_plantilla",
          title: "Modèle Excel d'Importation",
          definition:
            "Téléchargez le fichier modèle (.xlsx) pour importer des contacts sans erreurs.",
        },
        {
          id: "formato_telefonico_requerido",
          title: "Format Téléphonique Requis (E.164)",
          definition:
            "Les numéros doivent inclure l'indicatif pays sans symboles (ex: 33612345678) et comporter entre 8 et 13 chiffres. Les numéros locaux sans indicatif ne sont pas acceptés.",
        },
        {
          id: "filtro_antiban_lids",
          title: "Filtre Préventif Anti-LID de Groupes",
          definition:
            "L'outil analyse les colonnes et la longueur des numéros avant le traitement. Si le fichier provient d'une extraction de groupe (colonne 'Es Administrador' ou LIDs à 15 chiffres), le téléchargement est immédiatement rejeté pour protéger votre compte contre les sanctions de Meta.",
        },
      ],
    },
    {
      id: "administracion_contactos",
      title: "2. Administration des Contacts",
      description:
        "Gérez les enregistrements de chaque liste.",
      items: [
        {
          id: "ver_contactos",
          title: "Voir les Contacts de la Liste",
          definition:
            "Consultez les contacts d'une liste pour ajouter, modifier ou importer des fichiers.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "الدليل الرسمي لـ BotMix",
    title: "قوائم جهات الاتصال المقسمة",
    summary:
      "تنظيم وتقسيم الجماهير لحملات الرسائل الجماعية. إنشاء القوائم واستيراد جهات الاتصال عبر ملفات إكسل وإدارة السجلات بدقة.",
  },
  sections: [
    {
      id: "gestion_listas",
      title: "1. إنشاء وإدارة القوائم",
      description:
        "إنشاء قوائم بأسماء واضحة لتجميع العملاء حسب الاهتمامات أو المراحل.",
      items: [
        {
          id: "agregar_lista",
          title: "إضافة قائمة",
          definition:
            "حدد اسمًا فريدًا لقائمة جهات الاتصال لاستخدامها كهدف للحملات.",
        },
        {
          id: "descargar_plantilla",
          title: "نموذج استيراد إكسل",
          definition:
            "قم بتنزيل ملف إكسل النموذجي (.xlsx) بالأعمدة المطلوبة لاستيراد جهات الاتصال دون أخطاء.",
        },
        {
          id: "formato_telefonico_requerido",
          title: "تنسيق الهاتف المطلوب (E.164)",
          definition:
            "يجب أن تتضمن الأرقام رمز الدولة بدون رموز خاصة (مثال: 966501234567) وأن تتراوح بين 8 إلى 13 رقمًا. لا تُقبل الأرقام المحلية دون رمز الدولة.",
        },
        {
          id: "filtro_antiban_lids",
          title: "الفلتر الأمني الوقائي ضد معرفات المجموعات (LID)",
          definition:
            "يقوم المعالج بفحص الأعمدة وطول الأرقام قبل الاستيراد. إذا كان الملف مستخرجًا من مجموعة (عمود 'Es Administrador' أو أرقام LID المكونة من 15 رقمًا)، يتم إلغاء الرفع فورًا لمنع حظر خطك بسبب المراسلة غير المصرح بها.",
        },
      ],
    },
    {
      id: "administracion_contactos",
      title: "2. إدارة جهات الاتصال",
      description:
        "فحص وتعديل جهات الاتصال في كل قائمة.",
      items: [
        {
          id: "ver_contactos",
          title: "عرض جهات اتصال القائمة",
          definition:
            "ادخل إلى القائمة لإضافة جهات اتصال جديدة أو تعديل البيانات أو رفع ملفات مجمعة.",
        },
      ],
    },
  ],
};

export const CONTACT_LISTS_HELP_DATA = { es, en, pt, fr, ar };
